/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { BV_BASE_URL, BV_PASS_KEY } from '../constants';
import type { SubmitFeedbackOptions } from '../interface';
import type { SubmitFeedbackParams, SubmitFeedbackResponse } from '../interface/bv-types';
import { toUrlEncodedString } from '../utils/toUrlEncodedString';

const URL = `${BV_BASE_URL}/data/submitfeedback.json`;

const postSubmitFeedback = async ({
  contentId,
  contentType,
  feedbackType,
  vote,
}: SubmitFeedbackOptions) => {
  const params: SubmitFeedbackParams = {
    ContentType: contentType,
    ContentId: contentId,
    FeedbackType: feedbackType,
    Vote: vote,
    ApiVersion: 5.4,
    PassKey: BV_PASS_KEY,
  };

  const payload = toUrlEncodedString(params);

  const response = await axios.post<SubmitFeedbackResponse>(URL, payload, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
  return response.data;
};

export const useSubmitFeedbackMutation = () => {
  return useMutation({
    mutationFn: postSubmitFeedback,
  });
};
